export class LoanApplicationCommonInfoApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getApplicationCommonInfo({ applicationId }, config) {
    return this.#http.get(`api/applications/${applicationId}/common-info`, config);
  }

  async getApplicationLockInfo({ applicationId }) {
    return this.#http.get(`api/applications/${applicationId}/lock-info`);
  }
}
